import React, { useState } from 'react';
import { AiOutlineForm } from 'react-icons/ai';
import { FaCalendarAlt, FaCheckSquare, FaDesktop, FaFileUpload, FaMobileAlt, FaRegFileAlt } from 'react-icons/fa';
import { FaHashtag } from 'react-icons/fa6';

const CustomOrderFields = () => {
    
    const [activeTab2, setActiveTab2] = useState('web');

    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];


    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => !tab.disabled && setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? 'bg-[#1a9588] text-white shadow-md'
                        : 'bg-[#dbf4f1] text-gray-600 hover:bg-[#b9ece6] bg-gray-700 hover:bg-gray-600'
                        } ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={tab.disabled}
                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );

    const fields = [
        { icon: <FaRegFileAlt className="text-blue-500 w-5 h-5" />, label: "Text", description: "for single line text" },
        { icon: <FaHashtag className="text-green-500 w-5 h-5" />, label: "Number", description: "for numeric values" },
        { icon: <FaCalendarAlt className="text-yellow-500 w-5 h-5" />, label: "Date", description: "for dates" },
        { icon: <FaCheckSquare className="text-purple-500 w-5 h-5" />, label: "Checkbox", description: "for yes or no" },
        { icon: <FaFileUpload className="text-red-500 w-5 h-5" />, label: "File Upload", description: "for attaching documents in JPG or PDF format" },
    ];

    return (
        <div>
            <div className="flex items-center gap-4 mb-8">
                <AiOutlineForm className="text-pink-600 text-5xl" />
                <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">Custom Order Fields</h1>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
                <div className="flex flex-wrap gap-2">
                    <span className="bg-pink-600 text-white px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Seller
                    </span>
                    <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Buyer
                    </span>
                </div>
                <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Web
                    </span>
              
                    <span className="bg-green-100 text-green-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Android
                    </span>
                </div>
            </div>
            <p className="text-start mb-6 text-gray-600 text-gray-300">
                Every business operates differently. Custom Order Fields give you a flexible way to tailor the Selzor platform to your workflow. These fields are particularly useful when using Selzor Order Processing, where orders move from New to Confirmed and finally to Complete. Once an order is marked as complete, notifications are sent to the buyer and all linked Sales Reps. During order completion, you might want to share invoices, shipping details, or other documents with your buyer—Custom Order Fields let you do exactly that. You can define the specific information you want to provide to your buyer when an order is completed. These fields can be created in the following types:
            </p>

            <div className="text-start bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                {fields.map((field, index) => (
                    <div key={index} className="flex items-start gap-4 mb-4">
                        <div className="mt-1">{field.icon}</div>
                        <div>
                            <p className="font-semibold text-gray-800">{field.label}</p>
                            <p className="text-gray-500 text-sm">{field.description}</p>
                        </div>
                    </div>
                ))}
                <p className="text-gray-600 mt-4 text-sm">
                    By defining these fields, you can customise the format in which you wish to send this information to your buyers.
                </p>
            </div>


            <div className='my-5'>
                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">Add / Update Custom Order Fields</h3>
                    <p className="text-gray-600 mb-6">
                        Custom Order Fields can be managed in the 'Settings' section. To create a new field, click 'Add New' and provide the field label, a description for internal use, select the field type (Text, Number, Date, Checkbox, or File Upload), and indicate whether the field is mandatory
                    </p>
                </div>
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src=""
                        alt={`${activeTab2} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start">
                For Custom Order Fields that allow File Uploads, each attachment can be up to 5 MB in size. Supported file formats are JPG and PDF. Uploaded files remain valid for 30 days from the upload date.
            </div>

            <div className='my-4'>
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src=""
                        alt={`${activeTab2} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className="bg-red-100 text-red-800 p-4 rounded-lg border border-red-300 text-start">
                Custom Order Fields can be removed if needed. Deleting a field does not erase the data associated with that field in previously saved orders.
            </div>


            <div className='my-5'>
                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">Mark Order as Complete</h3>
                    <p className="text-gray-600 mb-6">
                        Custom Order Fields can be seen in action when you mark an order as complete.
                    </p>
                </div>
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src=""
                        alt={`${activeTab2} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

        </div>
    );
};

export default CustomOrderFields;